import React, { useContext, useEffect, useState } from "react";

import { Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LabelStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { ButtonWithIcon } from "../../../../components/styled/CustomElements";
import {
  AddBtn,
  Cancel,
  CancelWhite,
} from "../../../../components/styled/AllImages";
import { LeadFormWrapper } from "./style";
import FormData from "form-data";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomRadioButton from "../../../../components/common/radioButtons/CustomRadio";
import CustomCheckbox from "../../../../components/common/radioButtons/CustomCheckbox";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { SelectionDropdown } from "../../../../components/styled/FormElements";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import VisitorApi from "../../../../services/api/visitorApi";
import FloatingPhoneInput from "../../../../components/common/inputFields/FloatingPhoneInput";
import { AuthContext } from "../../../../context/authContext";
import { requireAuthNavigate } from "../../../../utils";
import InquiryLoginRequired from "./InquiryLoginRequired";

const LeadForm = () => {
  const {
    t,
    i18n: { dir, language },
  } = useTranslation();
  const isRTL = dir() === "rtl";
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const { username, id } = useParams();

  const [onChangeData, setOnChangeData] = useState({ user_id: id });
  const [formValidationErrors, setFormValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showBox, setShowBox] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [propertyType, setPropertyType] = useState("");
  const [bedroomActive, setBedroomActive] = useState(false);
  const [propertyState, setPropertyState] = useState({
    Apartment: false,
    Villa: false,
    Palace: false,
    Land: false,
    Building: false,
    Chalet: false,
    Farm: false,
    Duplex: false,
    Floor: false,
    "Rest House": false,
    terms_conditions: false,
  });
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isResidential, setIsResidential] = useState(null);
  const [cityInputs, setCityInputs] = useState([{}]);

  const addCityInput = () => {
    setCityInputs([...cityInputs, {}]); // add one more empty input
  };

  const validationSchema = Yup.object().shape({
    inquiry_type: Yup.string().required("validate_inquiry_type"),
    property_category: Yup.string().required("validate_property_category"),
    property_type_id: Yup.array().min(1).required("validate_property_type"),
    price_range: Yup.string().required("validate_price_range"),
    full_name: Yup.string().required("validate_full_name"),
    phone_number: Yup.string().required("Phone_requried"),
    cityInputs: Yup.array()
      .min(1, "validate_city_id")
      .of(
        Yup.object().shape({
          city_id: Yup.string().required("validate_city_id"),
          district_ids: Yup.array().notRequired(),
        })
      ),
    // city_id: Yup.string().required("validate_city_id"),
    bedrooms: Yup.array().nullable().notRequired(),
    // bedrooms: Yup.array().when([], {
    //   is: () => isResidential && bedroomActive,
    //   then: (schema) =>
    //     schema.min(1, "fieldRequired").required("fieldRequired"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    district_ids: Yup.array()
      .min(1)
      .max(5, "district_max_validate")
      .notRequired(),
    // customer_type: Yup.string().required("validate_customer_type"),
  });

  const radioOptions = [
    { id: "1", label: t("Buy") },
    { id: "2", label: t("Rent") },
    { id: "3", label: t("Sale") },
  ];
  const categoryOptions = [
    { id: "1", label: t("Residential") },
    { id: "2", label: t("Commercial") },
  ];

  const handleSelectorChange = (e, id) => {
    let propertyName;
    if (id === "1") {
      setIsResidential(true);
      propertyName = t("Residential");
      setOnChangeData((prevData) => ({
        ...prevData,
        property_category: "1",
        property_type_id: [],
        bedrooms: [],
        inside_mall_only_bit: 0,
      }));
      getPropertyTypes(id);
    } else {
      setIsResidential(false);
      propertyName = t("Commercial");
      setOnChangeData((prevData) => ({
        ...prevData,
        property_category: "2",
        property_type_id: [],
        bedrooms: [],
        inside_mall_only_bit: 0,
      }));
      getPropertyTypes(id);
    }
    const newPropertyType = propertyName;

    // Reset propertyState when switching property type
    const resetPropertyState = Object.keys(propertyState).reduce(
      (acc, property) => {
        acc[property] = false;
        return acc;
      },
      {}
    );
    setPropertyState(resetPropertyState);

    // Reset bedroomState when switching property type
    const resetBedroomState = Object.keys(bedroomState).reduce(
      (acc, bedroom) => {
        acc[bedroom] = false;
        return acc;
      },
      {}
    );
    setBedroomState(resetBedroomState);

    setPropertyType(newPropertyType);
    setBedroomActive(propertyState[newPropertyType]); // Set bedroomActive based on the new property type
    setShowBox(false);
  };

  const handlePropertyChange = (propertyId, e) => {
    setPropertyState((prevState) => {
      const newPropertyState = {
        ...prevState,
        [propertyId]: !prevState[propertyId],
      };

      setOnChangeData((prevData) => {
        let updatedPropertyIds = prevData["property_type_id"] || [];

        if (newPropertyState[propertyId]) {
          // Add the selected property ID to the array (if not already present)
          updatedPropertyIds = [...updatedPropertyIds, propertyId];
        } else {
          // Remove the unselected property ID from the array
          updatedPropertyIds = updatedPropertyIds.filter(
            (id) => id !== propertyId
          );
        }

        return {
          ...prevData,
          property_type_id: updatedPropertyIds,
        };
      });

      // Showroom and Office Space Logic
      const showroomId = 11;
      const officeSpaceId = 13;
      const insideMallId = "terms_conditions";
      const farmId = 7;
      const landId = 4;
      const commercialLandId = 14;
      const buildingId = 12;
      const OthersId = 15;

      const isShowroomOrOfficeSelected =
        // newPropertyState[showroomId] || newPropertyState[officeSpaceId];
        newPropertyState[officeSpaceId];

      if (isShowroomOrOfficeSelected) {
        newPropertyState[insideMallId] = true;
      } else {
        delete newPropertyState[insideMallId];
      }

      // Check if other properties are selected
      const isOtherPropertySelected = Object.keys(newPropertyState)
        .map(Number)
        .filter(
          (prop) =>
            prop !== officeSpaceId &&
            prop !== farmId &&
            prop !== landId &&
            prop !== showroomId &&
            prop !== commercialLandId &&
            prop !== buildingId &&
            prop !== OthersId
        )
        .some((prop) => newPropertyState[prop]);
      setShowBox(isShowroomOrOfficeSelected);
      setBedroomActive(isOtherPropertySelected);

      return newPropertyState;
    });
  };

  const [bedroomState, setBedroomState] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    "9+": false,
    Studio: false,
  });

  const handleBedroomChange = (bedroom) => {
    setBedroomState((prevState) => {
      const newBedroomState = {
        ...prevState,
        [bedroom]: !prevState[bedroom],
      };

      setOnChangeData((prevData) => {
        const updatedBedrooms = newBedroomState[bedroom]
          ? [...(prevData["bedrooms"] || []), bedroom]
          : (prevData["bedrooms"] || []).filter((b) => b !== bedroom);

        return { ...prevData, bedrooms: updatedBedrooms };
      });

      return newBedroomState;
    });
  };

  const [cityData, setCityData] = useState([]);
  const [selectedCity, setSelectedCity] = useState();
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [cityNameSelect, setCityNameSelect] = useState("");
  const [districts, setDistricts] = useState([]);
  const [selectedDistrictNames, setSelectedDistrictNames] = useState([]);
  const [currentCityIndex, setCurrentCityIndex] = useState(null);
  const handleAddDistricts = async (index) => {
    await setCurrentCityIndex(index);
    setShowModal(true);
  };

  const handleCityChange = (index, e) => {
    const city = e.target.value;
    const filteredCity = cityData?.find(
      (item) => Number(item?.value) === Number(city)
    );

    setSelectedCity(city);
    getDistrictData(filteredCity?.id, city, index);

    setCityInputs((prev) => {
      const newInputs = [...prev];
      newInputs[index] = {
        ...newInputs[index],
        city_id: filteredCity?.id,
        district_ids: [],
        districts_list: [],
      };
      return newInputs;
    });

    // setShowModal(true);
    setSelectedDistricts([]);
    setSelectedDistrictNames([]);
  };

  const handleClose = () => {
    setShowModal(false);
  };
  const handleContinueClick = () => {
    setIsConfirm(true);
    setShowModal(false);
  };
  const getCityData = async () => {
    try {
      const body = await VisitorApi.getCitiesList();
      if (body?.data) {
        setCityData(
          body?.data?.map((city) => ({
            ...city,
            value: city?.id,
            label: isRTL ? city?.name_ar : city?.name_en,
          }))
        );
      }
    } catch (error) {}
  };

  const getPropertyTypes = async (type) => {
    try {
      const body = await VisitorApi.getPropertyTypes(type);

      if (body?.data) {
        const mappedProperties = body.data.map((property) => ({
          ...property,
          value: property.id,
          label: isRTL ? property.ar_name : property.en_name,
        }));

        const othersProperty = {
          id: 15,
          value: 15,
          label: t("others"),
          ar_name: t("others"),
          en_name: t("others"),
        };
        const sortOthersLast = (list) => {
          const others = list.filter((p) => Number(p.id) === 15);
          const rest = list.filter((p) => Number(p.id) !== 15);
          return [...rest, ...others];
        };
        const finalProperties = sortOthersLast(
          Number(type) === 1
            ? [...mappedProperties, othersProperty]
            : mappedProperties
        );

        setPropertyTypes(finalProperties);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getDistrictData = async (id, city, index) => {
    try {
      const body = await VisitorApi.getDistricts(id);
      if (body?.data) {
        // console.log('city data', response.data.data[0].name_ar);
        setDistricts(body?.data);
        setCityInputs((prev) => {
          let newInputs = [...prev];
          newInputs[index] = {
            ...newInputs[index],
            districts_list: body?.data,
          };
          console.log(newInputs);

          return newInputs;
        });
      } else {
        const districtData = cityData?.filter(
          (city) => parseInt(city?.value) === parseInt(id)
        );
        setDistricts(districtData);
        setCityInputs((prev) => {
          let newInputs = [...prev];
          newInputs[index] = {
            ...newInputs[index],
            districts_list: districtData,
          };
          return newInputs;
        });
      }
      // if(response?.code === 204) {
      //   setDistricts([{name_en: city, id}]);
      //   setSelectedDistricts([{name_en: city, id}])
      // }
    } catch (error) {
      // console.log(error.message);
    }
  };
  useEffect(() => {
    getCityData();
    // if (selectedCity) getDistrictData(selectedCity);
  }, [isRTL]);
  useEffect(() => {
    const cityName = cityData.find(
      (city) => city.city_id == selectedCity
    )?.name_en;
    const cityNameInRTL = cityData.find(
      (city) => city.city_id == selectedCity
    )?.name_ar;
    const selectedCityName = isRTL ? cityNameInRTL : cityName;
    // console.log('__', selectedCityName);

    setCityNameSelect(selectedCityName || "");
  }, [selectedCity, cityData, isRTL]);

  const handleDistrictChange = (index, e) => {
    const districtId = parseInt(e.target.value);
    const districtName = districts.find(
      (district) => district.id === districtId
    );
    const singleName = isRTL ? districtName.name_ar : districtName.name_en;

    let updatedDistricts;
    let updatedNames;

    if (e.target.checked) {
      if (
        !selectedDistricts.includes(districtId) &&
        selectedDistricts.length < 5
      ) {
        updatedDistricts = [...selectedDistricts, districtId];
        updatedNames = [...selectedDistrictNames, singleName];
      } else {
        return;
      }
    } else {
      updatedDistricts = selectedDistricts.filter((id) => id !== districtId);
      updatedNames = selectedDistrictNames.filter(
        (name) => name !== singleName
      );
    }

    setSelectedDistricts(updatedDistricts);
    setSelectedDistrictNames(updatedNames);

    setOnChangeData((prev) => ({
      ...prev,
      district_ids: updatedDistricts,
    }));

    setCityInputs((prev) => {
      const newInputs = [...prev];
      newInputs[index] = {
        ...newInputs[index],
        district_ids: updatedDistricts,
      };
      return newInputs;
    });
  };

  const validateFormData = async () => {
    try {
      await validationSchema.validate(onChangeData, { abortEarly: false });
      setFormValidationErrors({});
      return true;
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      setFormValidationErrors(errors);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !requireAuthNavigate(
        navigate,
        isAuthenticated,
        `${location.pathname}${location.search}`
      )
    ) {
      return;
    }
    const formData = new FormData();
    const isValidData = await validateFormData();
    if (!isValidData) return;

    Object.entries(onChangeData).forEach(([key, value]) => {
      if (key === "district_ids") return;

      if (Array.isArray(value)) {
        if (key === "bedrooms") {
          value.forEach((val) =>
            formData.append(
              `${key}[]`,
              val === "9+" ? 10 : val === "Studio" ? 11 : val
            )
          );
        } else {
          value.forEach((val) => formData.append(`${key}[]`, val));
        }
      } else {
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      }
    });
    cityInputs.forEach((input) => {
      if (input.city_id) {
        formData.append("city_id[]", input.city_id);
      }
      if (Array.isArray(input.district_ids)) {
        input.district_ids.forEach((id) => {
          formData.append("district_ids[]", id);
        });
      }
    });

    try {
      setIsLoadingSubmit(true);
      const body = await VisitorApi.createInquiry(formData);
      if (body?.code === 200) {
        setOnChangeData(null);
        navigate(`/profile/${username}`, { replace: true });
        toast.success(t("inquiry_successful"));
      }
    } catch (error) {
      // Optionally log or show error
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const [formErrors, setFormErrors] = useState({
    // propertyMain: '',
    // propertyCategory: '',
    // propertyType: '',
    // priceRange: '',
    // fullName: '',
    // phoneNumber: '',
    // cityId: '',
    // customerType: '',
    // Add more fields as needed
  });
  const validateForm = (formData) => {
    const errors = {};

    const inquiryType = formData.get("inquiry_type");
    if (!inquiryType) {
      errors.inquiryType = t("Select_any_one");
    }

    const propertyCategory = formData.get("property_category");
    if (!propertyCategory) {
      errors.propertyCategory = t("Select_any_one");
    }

    const priceRange = formData.get("price_range");
    if (!priceRange) {
      errors.priceRange = t("Select_the_price_range");
    }
    const fullName = formData.get("full_name");
    if (!fullName) {
      errors.fullName = t("Name_requried");
    }

    const phoneNumber = formData.get("phone_number");
    if (!phoneNumber) {
      errors.phoneNumber = t("Phone_requried");
    }
    const cityId = formData.get("city_id");
    if (!cityId) {
      errors.cityId = t("Select_city");
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      setFormErrors({});
    }
    return Object.keys(errors).length === 0;
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    if (value) {
      setOnChangeData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleInsideMallChange = (e) => {
    const isChecked = e.target.checked;

    setOnChangeData((prevData) => {
      if (isChecked) {
        return { ...prevData, inside_mall_only_bit: 1 };
      } else {
        const { inside_mall_only_bit, ...rest } = prevData;
        return rest;
      }
    });
  };

  const handlePriceChange = (price) => {
    setOnChangeData((prevData) => ({
      ...prevData,
      price_range: price,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOnChangeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRemoveCity = (removeIndex) => {
    const updatedInputs = cityInputs.filter(
      (_, index) => index !== removeIndex
    );
    setCityInputs(updatedInputs);
  };

  if (!isAuthenticated) {
    return <InquiryLoginRequired />;
  }

  return (
    <LeadFormWrapper>
      <form className="py-3" onSubmit={handleSubmit}>
        <Row>
          <Col lg={12} md={12}>
            <Box className="field-box border-bottom-line">
              <HeadingStyled className="label-heading">
                {t("looking_property")}
              </HeadingStyled>
              <Box className="active-radio-container d-flex gap-2 flex-wrap">
                {radioOptions.map((option) => (
                  <Box key={option.id}>
                    <CustomRadioButton
                      name="inquiry_type"
                      label={t(option.label)}
                      value={option.id}
                      checked={onChangeData?.inquiry_type == option?.id}
                      onChange={onChangeHandler}
                    />
                  </Box>
                ))}
              </Box>
              {formValidationErrors.inquiry_type && (
                <div className="error-message">
                  {t(formValidationErrors.inquiry_type)}
                </div>
              )}
            </Box>
          </Col>
          <Col lg={12} md={12}>
            <Box className="field-box border-bottom-line">
              <Box className="property-categories my-2">
                <HeadingStyled className="label-heading mb-2">
                  {t("Property_category")}{" "}
                </HeadingStyled>
                <Box className="active-radio-container d-flex gap-2 flex-wrap">
                  {categoryOptions.map((option) => (
                    <Box key={option.id}>
                      <CustomRadioButton
                        name="property_category"
                        label={t(option.label)}
                        value={option.id}
                        checked={option.label === propertyType}
                        onChange={(e) => handleSelectorChange(e, option.id)}
                      />
                    </Box>
                  ))}
                </Box>
                {formValidationErrors.property_category && (
                  <div className="error-message mt-2">
                    {t(formValidationErrors.property_category)}
                  </div>
                )}
                {propertyType === t("Residential") && (
                  <Box className="property-type-container common-space">
                    <HeadingStyled size="14px" className="mb-2">
                      {t("Property_Types")}{" "}
                    </HeadingStyled>
                    <Box className="active-check-container d-flex gap-2 align-items-center flex-wrap">
                      {propertyTypes?.map((property, i) => (
                        <Box key={i}>
                          <CustomCheckbox
                            label={property?.label}
                            id={property?.value}
                            value={property?.value}
                            name="property_type_id"
                            checked={!!propertyState[property?.value]}
                            onChange={() =>
                              handlePropertyChange(property?.value)
                            }
                          />
                        </Box>
                      ))}
                    </Box>
                    {formValidationErrors.property_type && (
                      <div className="error-message mt-2">
                        {t(formValidationErrors.property_type)}
                      </div>
                    )}
                  </Box>
                )}

                {propertyType === t("Commercial") && (
                  <Box className="Commercial-container common-space">
                    <HeadingStyled size="14px" className="mb-2">
                      {t("Property_Types")}
                    </HeadingStyled>
                    <Box className="active-check-container d-flex gap-2 align-items-center flex-wrap">
                      {propertyTypes?.map((property, i) => (
                        <Box key={i}>
                          <CustomCheckbox
                            label={property?.label}
                            id={property?.value}
                            value={property?.value}
                            name="property_type[]"
                            checked={!!propertyState[property?.value]} // Ensures correct toggle behavior
                            onChange={(e) => {
                              handlePropertyChange(
                                property?.value,
                                e,
                                property?.label
                              );
                              // handleShowroomChange(e);
                            }}
                          />
                        </Box>
                      ))}
                    </Box>

                    {formValidationErrors.property_type_id && (
                      <div className="error-message">
                        {t(formValidationErrors.property_type_id)}
                      </div>
                    )}

                    {showBox && (
                      <Box className="check-box d-flex align-items-center gap-2 my-2">
                        <input
                          type="checkbox"
                          name="terms_conditions"
                          value={t("Inside_Mall_Only")}
                          id="terms-conditions"
                          onChange={handleInsideMallChange}
                        />
                        <LabelStyled
                          className="LabelStyled"
                          size="14px"
                          htmlFor="terms-conditions"
                        >
                          {t("Inside_Mall_Only")}
                        </LabelStyled>
                      </Box>
                    )}
                  </Box>
                )}

                {bedroomActive && (
                  <Box className="bedroom-container common-space">
                    <HeadingStyled size="14px" className="mb-2">
                      {t("Bedrooms")}
                    </HeadingStyled>
                    <Box className="active-check-container d-flex gap-2 flex-wrap">
                      {Object.keys(bedroomState).map((bedroom) => (
                        <Box key={bedroom}>
                          <CustomCheckbox
                            id={bedroom}
                            label={t(bedroom)}
                            value={t(bedroom)}
                            name="bedrooms"
                            checked={bedroomState[bedroom]}
                            onChange={() => handleBedroomChange(bedroom)}
                          />
                        </Box>
                      ))}
                    </Box>
                    {formValidationErrors.bedrooms && (
                      <div className="error-message">
                        {t(formValidationErrors.bedrooms)}
                      </div>
                    )}
                  </Box>
                )}
              </Box>
              <Box className="price-range my-2">
                <HeadingStyled className="label-heading mb-2">
                  {t("Price_Range")}
                </HeadingStyled>
                <Box className="active-radio-container d-flex gap-2 flex-wrap">
                  {[
                    { id: "More_Then_2M", value: 1 },
                    { id: "1M_To_2M", value: 2 },
                    { id: "500K_To_1M", value: 3 },
                    { id: "Less_Then_500k", value: 4 },
                  ].map((range) => (
                    <div className="w-full" key={range.id}>
                      <CustomRadioButton
                        name="price_range"
                        label={t(range.id)}
                        value={t(range.value)}
                        checked={onChangeData?.price_range == range.value}
                        onChange={() => handlePriceChange(t(range.value))}
                        // checked={option.label === propertyType}
                        // onChange={(e) => handleSelectorChange(e, option.id)}
                      />
                    </div>
                  ))}
                </Box>
                {formValidationErrors.price_range && (
                  <div className="error-message mt-2">
                    {t(formValidationErrors.price_range)}
                  </div>
                )}
              </Box>
            </Box>
          </Col>

          <Col lg={6} md={12}>
            <Box className="field-box">
              <HeadingStyled className="label-heading">
                {t("Full_Name")}{" "}
              </HeadingStyled>
              <ValidatedInput
                name="full_name"
                // label={"Full_Name"}
                type="input"
                fieldType="text"
                placeholder={t("Full_Name_place")}
                className={"w-100 mb-0 combined flex-wrap p-0"}
                value={onChangeData?.full_name || ""}
                onChange={handleInputChange}
              />
              {formValidationErrors.full_name && (
                <div className="error-message">
                  {t(formValidationErrors.full_name)}
                </div>
              )}
            </Box>
          </Col>
          <Col lg={6} md={12}>
            <Box className="field-box">
              <HeadingStyled className="label-heading">
                {" "}
                {t("Phone_Number")}{" "}
              </HeadingStyled>
              <FloatingPhoneInput
                name="phone_number"
                // label={"Full_Name"}
                placeholder={t("Phone_Number_place")}
                className={"w-100 mb-2 mt-2 combined flex-wrap p-0"}
                value={onChangeData?.phone_number || ""}
                onChange={handleInputChange}
              />

              {formValidationErrors.phone_number && (
                <div className="error-message">
                  {t(formValidationErrors.phone_number)}
                </div>
              )}
            </Box>
          </Col>
          <>
            {cityInputs.map((_, index) => (
              <Col lg={12} md={12} key={index}>
                <Box className="field-box border-bottom-line">
                  <Box className="d-flex justify-content-between align-items-center">
                    <HeadingStyled className="label-heading">
                      {t("City")}
                    </HeadingStyled>
                    {index > 0 && (
                      <ButtonStyled
                        icon={CancelWhite}
                        type="button"
                        label={t("remove")}
                        iconWidth="14px"
                        bg={"var(--themeColorSecondary)"}
                        onClick={() => handleRemoveCity(index)}
                      />
                    )}
                  </Box>

                  <SelectionDropdown
                    name={`city_id_${index}`}
                    placeholder={t("City")}
                    options={cityData}
                    onChange={(e) => handleCityChange(index, e)}
                    // add value prop here if you want controlled inputs
                  />

                  {formValidationErrors?.city_id && (
                    <div className="error-message">
                      {t(formValidationErrors?.city_id)}
                    </div>
                  )}

                  {selectedCity && (
                    <Box className="field-box">
                      <SpanStyled size="12px" className="label-heading">
                        {t("District")}
                      </SpanStyled>
                      <Box className="d-flex align-items-center flex-wrap gap-2">
                        <ButtonWithIcon
                          type="button"
                          icon={AddBtn}
                          label={t("Add_districts")}
                          onClick={() => handleAddDistricts(index)}
                        />
                        {isConfirm &&
                          cityInputs[index]?.district_ids?.length > 0 && (
                            <Box className="selected-data-show">
                              {cityInputs[index]?.districts_list
                                .filter((dist) =>
                                  cityInputs[index]?.district_ids?.includes(
                                    dist.id
                                  )
                                )
                                .map((name, idx) => (
                                  <span key={idx}>
                                    {language === "en"
                                      ? name.name_en
                                      : name.name_ar}{" "}
                                    |
                                  </span>
                                ))}
                            </Box>
                          )}
                      </Box>
                      {formValidationErrors.district_ids && (
                        <div className="error-message">
                          {t(formValidationErrors.district_ids)}
                        </div>
                      )}
                    </Box>
                  )}
                </Box>
              </Col>
            ))}

            {/* Add button to add one more city input */}
            {cityInputs[0]?.city_id && (
              <Box className="d-flex align-items-center justify-content-end mt-3">
                <ButtonStyled
                  type="button"
                  label={t("add_city")}
                  onClick={() => setCityInputs([...cityInputs, {}])}
                />
              </Box>
            )}
          </>

          <Col lg={12} md={12}>
            <Box className="field-box border-bottom-line">
              <HeadingStyled className="label-heading">
                {t("Customer_type")}
              </HeadingStyled>
              <Box className="active-radio-container d-flex gap-2 flex-wrap">
                {[
                  { value: 1, id: "Property_seeker" },
                  { value: 2, id: "Broker" },
                  { value: 3, id: "Investor" },
                  { value: 4, id: "developer" },
                  { value: 5, id: "service_provider" },
                  { value: 6, id: "others" },
                ]?.map((type) => (
                  <div className="w-full" key={type.id}>
                    <CustomRadioButton
                      name="customer_type"
                      label={t(type.id)}
                      value={t(type.value)}
                      checked={onChangeData?.customer_type == type?.value}
                      onChange={handleInputChange}
                      // checked={option.label === propertyType}
                      // onChange={(e) => handleSelectorChange(e, option.id)}
                    />
                  </div>
                ))}
              </Box>
              {/* {formErrors.customerType && <div className="error-message">{formErrors.customerType}</div>} */}
            </Box>
          </Col>
          <Col style={{ width: "100%" }} lg={6} md={12}>
            <Box className="field-box">
              <HeadingStyled className="label-heading">
                {t("message")}{` (${t("Optional")})`}{" "}
              </HeadingStyled>
              <ValidatedInput
                name="message"
                // label={"Full_Name"}
                type="textarea"
                fieldType="text"
                placeholder={t("message")}
                className={"w-100 mb-0 combined flex-wrap p-0"}
                value={onChangeData?.message || ""}
                onChange={handleInputChange}
              />
              {formValidationErrors.full_name && (
                <div className="error-message">
                  {t(formValidationErrors.message)}
                </div>
              )}
            </Box>
          </Col>
          <Box className="d-flex align-items-center gap-2 justify-content-end mt-3">
            {isLoading ? (
              <p className="loading-btn">
                <span className="spinner"></span>
              </p>
            ) : null}
            <ButtonStyled
              isLoading={isLoadingSubmit}
              label={t("submit")}
              bg="var(--themeColorSecondary)"
              type="submit"
            />
            {/* <p className='loading-btn'><span className='spinner'></span></p> */}
          </Box>
        </Row>

        {showModal && (
          <Modal size="xl" show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {t("Select_Districts_in")} {cityNameSelect}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box className="select-district d-flex gap-2 flex-wrap">
                {cityInputs[currentCityIndex]?.districts_list?.length > 0 ? (
                  cityInputs[currentCityIndex]?.districts_list?.map(
                    (district, idx) => {
                      const { id, name_ar, name_en } = district;
                      const districtName = isRTL ? name_ar : name_en;
                      return (
                        <Box
                          key={idx}
                          className="check-box d-flex align-items-center gap-2 my-2"
                        >
                          <CustomCheckbox
                            label={districtName}
                            name="districts_id[]"
                            value={id}
                            checked={cityInputs[
                              currentCityIndex
                            ]?.district_ids.includes(id)}
                            onChange={(e) =>
                              handleDistrictChange(currentCityIndex, e)
                            }
                            disabled={
                              cityInputs[currentCityIndex]?.district_ids
                                .length === 5 &&
                              !cityInputs[
                                currentCityIndex
                              ]?.district_ids.includes(id)
                            }
                          />
                        </Box>
                      );
                    }
                  )
                ) : (
                  <Box className="check-box d-flex align-items-center gap-2 my-2">
                    <LabelStyled
                      className="LabelStyled"
                      style={{ fontSize: "14px" }}
                    >
                      {cityNameSelect}
                    </LabelStyled>
                  </Box>
                )}
              </Box>
            </Modal.Body>
            <Modal.Footer>
              <Box className="selected-data-show">
                {cityInputs[currentCityIndex]?.districts_list
                  .filter((dist) =>
                    cityInputs[currentCityIndex]?.districts_list?.includes(
                      dist.id
                    )
                  )
                  ?.map((name, idx) => (
                    <span key={idx}>
                      {language === "en" ? name?.name_en : name?.name_ar} |{" "}
                    </span>
                  ))}
              </Box>
              <ButtonStyled
                className="district-btn"
                label={t("Continue")}
                bg="var(--themeColorSecondary)"
                onClick={handleContinueClick}
              />
            </Modal.Footer>
          </Modal>
        )}
      </form>
    </LeadFormWrapper>
  );
};

export default LeadForm;
